<template>
    <v-dialog :value="open" max-width="720px" persistent scrollable>
        <v-card class="variant-dialog-card">
            <div class="variant-dialog-header pa-5">
                <div class="variant-dialog-title">
                    <v-icon class="mr-2" color="white" size="20">mdi-call-split</v-icon>
                    Also change the other packages?
                </div>
                <div class="variant-dialog-subtitle mt-1">
                    These services are also booked on other packages for this group.
                </div>
            </div>

            <v-card-text class="pa-6">
                <div v-for="change in changes" :key="change.build_id" class="variant-change">
                    <div class="variant-change-summary">
                        <div class="variant-change-service">
                            <span class="variant-change-old">{{ change.service }}</span>
                            <span class="variant-change-dates">{{ change.dates }}</span>
                        </div>
                        <template v-if="change.replacement">
                            <v-icon small color="#3988AA" class="mx-2">mdi-arrow-right</v-icon>
                            <div class="variant-change-service">
                                <span class="variant-change-new">{{ change.replacement.service }}</span>
                                <span class="variant-change-dates">{{ change.replacement.dates }}</span>
                            </div>
                        </template>
                        <span v-else class="variant-change-removed ml-2">removed</span>
                    </div>
                    <div class="variant-change-packages">
                        Also on: <b>{{ change.packages.join(', ') }}</b>
                    </div>
                    <v-radio-group v-model="choices[change.build_id]" hide-details dense class="mt-2">
                        <v-radio v-if="change.replacement" value="replace"
                            :label="`Change it there too (keeps ${change.packages.length > 1 ? 'their' : 'its'} own nights or day)`" />
                        <v-radio v-else value="remove" label="Remove it there too" />
                        <v-radio value="keep"
                            :label="`Keep ${change.service} on ${change.packages.length > 1 ? 'those packages' : 'that package'} (it stays booked for ${change.packages.length > 1 ? 'them' : 'it'})`" />
                    </v-radio-group>
                </div>
                <div class="variant-dialog-hint">
                    Changed packages are re-priced. A new supplier starts as Unconfirmed.
                </div>
            </v-card-text>

            <v-divider />
            <v-card-actions class="pa-4">
                <v-spacer />
                <v-btn text class="variant-btn" @click="finish(null)">Cancel</v-btn>
                <v-btn depressed dark color="#3988AA" class="variant-btn" :disabled="!allChosen"
                    @click="finish(changes.map(c => ({ build_id: c.build_id, action: choices[c.build_id], replacement: c.replacement })))">
                    Save Quote
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Asked before the quote editor saves, when the save removes or replaces services that other
// packages (Copy Quote variants) also book. ask(changes) resolves with the variant_changes to send
// with update_custom_quote, or null if the agent cancels.
export default {
    data: () => ({
        open: false,
        changes: [],
        choices: {},
        resolver: null,
    }),
    computed: {
        allChosen() {
            return this.changes.every(change => !!this.choices[change.build_id])
        },
    },
    methods: {
        ask(changes) {
            this.changes = changes
            this.choices = {}
            this.open = true
            return new Promise(resolve => { this.resolver = resolve })
        },
        finish(result) {
            this.open = false
            if (this.resolver) this.resolver(result)
            this.resolver = null
        },
    },
}
</script>

<style lang="scss" scoped>
.variant-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
    font-family: Manrope;
}

.variant-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.variant-dialog-title {
    font-size: 18px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.variant-dialog-subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
}

.variant-change {
    padding: 12px 14px;
    margin-bottom: 12px;
    border: 1px solid #E3E8EC;
    border-radius: 8px;
    background-color: #F7FAFC;
}

.variant-change-summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.variant-change-service {
    display: flex;
    flex-direction: column;
}

.variant-change-old {
    font-size: 13px;
    font-weight: 600;
    color: #7C7C7C;
}

.variant-change-new {
    font-size: 13px;
    font-weight: 700;
    color: #101010;
}

.variant-change-dates {
    font-size: 11px;
    color: #9E9E9E;
}

.variant-change-removed {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #B23B3B;
}

.variant-change-packages {
    margin-top: 6px;
    font-size: 12px;
    color: #5F6B73;
}

.variant-dialog-hint {
    font-size: 11px;
    color: #9E9E9E;
}

.variant-btn {
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}
</style>
